<template>
    <div>
        <limitless-page-header title="Brevetikettutskrift">
            <template #header-elements>
                <limitless-page-header-button v-if="order_route" icon="icon-circle-left2" :route="order_route">Tillbaka till order</limitless-page-header-button>
            </template>
        </limitless-page-header>

        <div class="content">
            <form @submit.prevent="printLabel">
                <ValidationObserver ref="printlabelform">
                    <div class="card" style="max-width: 45vw;">
                        <div class="card-header bg-light header-elements-inline">
                            <h5 class="card-title">Adress</h5>
                        </div>
                        <div class="card-body">
                            <!-- Namn -->
                            <div class="row">
                                <div class="col-lg-12">
                                    <input-with-validation
                                        v-model="address.name"
                                        label="Namn"
                                        rules="required"
                                        vid="address.name"
                                        :disabled="busy_printing"
                                    />
                                </div>
                            </div>

                            <!-- Address lines -->
                            <div
                                v-for="(al, al_index) in address.address_lines"
                                :key="'a-line-' + al_index"
                                class="row"
                            >
                                <div class="col-lg-12">
                                    <input-with-validation
                                        v-model="address.address_lines[al_index]"
                                        :label="'Adressrad ' + (al_index + 1)"
                                        :rules="{required: al_index === 0}"
                                        :vid="'address.address_lines.' + al_index"
                                        :disabled="busy_printing"
                                    />
                                </div>
                            </div>

                            <!-- Stad och Postnummer -->
                            <div class="row">
                                <div class="col-lg-4">
                                    <input-with-validation
                                        v-model="address.postal_code"
                                        label="Postnummer"
                                        rules="required"
                                        vid="address.postal_code"
                                        :disabled="busy_printing"
                                    />
                                </div>
                                <div class="col-lg-8">
                                    <input-with-validation
                                        v-model="address.city"
                                        label="Stad"
                                        rules="required"
                                        vid="address.city"
                                        :disabled="busy_printing"
                                    />
                                </div>
                            </div>

                            <!-- Land -->
                            <div class="row">
                                <div class="col-lg-12">
                                    <select-with-validation
                                        v-model="address.country"
                                        label="Land"
                                        rules="required"
                                        vid="address.country"
                                        :disabled="busy_printing"
                                        component="country-filter"
                                        :reduce="(opt) => opt.id"
                                    />
                                </div>
                            </div>

                            <div class="form-group">
                                <label class="d-block">Frankering?</label>
                                <div class="custom-control custom-radio custom-control-inline">
                                    <input type="radio" class="custom-control-input" name="template" id="rdo-without-franking" v-model="template" value="adresslapp_utan_frankering">
                                    <label class="custom-control-label" for="rdo-without-franking">UTAN frankering</label>
                                </div>
                                <div class="custom-control custom-radio custom-control-inline">
                                    <input type="radio" class="custom-control-input" name="template" id="rdo-with-franking" v-model="template" value="adresslapp_med_frankering" :disabled="!smalllabel_allow_franking">
                                    <label class="custom-control-label" for="rdo-with-franking">MED frankering</label>
                                </div>
                            </div>

                            <div class="row" v-if="label.prod_order_id || label.return_order_id">
<!--                                <div class="col-lg-12">-->
<!--                                    <div class="custom-control custom-control-inline custom-checkbox mb-3">-->
<!--                                        <input type="checkbox" class="custom-control-input" id="chk-set_status" v-model="label.print_product">-->
<!--                                        <label class="custom-control-label" for="chk-set_status">Skriv ut produkt</label>-->
<!--                                    </div>-->
<!--                                </div>-->

                                <div class="col-lg-12">
                                    <div class="custom-control custom-control-inline custom-checkbox mb-3">
                                        <input type="checkbox" class="custom-control-input" id="chk-set_status" v-model="label.set_order_status">
                                        <label class="custom-control-label" for="chk-set_status">Sätt status till 500 Levererad</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-lg-3 d-flex">
                            <div class="col-form-label pr-1">Skrivare:</div>
                            <div class="flex-grow-1">
                                <select-with-validation
                                    option-label="name"
                                    :options="smalllabel_printers"
                                    vid="printer_tag"
                                    label="Skrivare"
                                    v-model="printer_tag"
                                    :reduce="opt => opt.tag"
                                    placeholder="-- Välj skrivare --"
                                    :disabled="busy_printing"
                                    hide-label
                                />
                                <div class="custom-control custom-checkbox mt-3">
                                    <input type="checkbox" class="custom-control-input" id="chk-default-printer" v-model="set_as_defualt_printer">
                                    <label class="custom-control-label" for="chk-default-printer">Sätt vald skrivare som standardskrivare på denna dator</label>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-3">
                            <limitless-button
                                type="submit"
                                saved-text="Skickat till skrivaren!"
                                :busy="busy_printing"
                                ref="btnprintlabel"
                            >
                                Skriv ut brevetikett
                            </limitless-button>
                        </div>
                    </div>
                </ValidationObserver>
            </form>
        </div>
    </div>
</template>

<script>
import LimitlessPageHeader from '@components/Layout/partials/LimitlessPageHeader';
import LimitlessPageHeaderButton from '@components/Layout/partials/LimitlessPageHeaderButton';
import InputWithValidation from '@components/Form/InputWithValidation';
import apiClient from '@services/ApiClient';
import getError from '@services/ErrorHelper';
import LimitlessButton from '@components/Limitless/LimitlessButton';
import Cookies from 'js-cookie';
import SelectWithValidation from '@components/Form/SelectWithValidation.vue';
import {
    hasRole,
} from '@services/Helpers';
import PrinterRepository from '@services/repositories/Printer/PrinterRepository';

export default {
    name: 'NtapsPrintLabel',
    components: {
        SelectWithValidation,
        LimitlessPageHeader,
        LimitlessPageHeaderButton,
        LimitlessButton,
        InputWithValidation,
    },
    data: () => ({
        set_as_defualt_printer: false,
        busy_printing: false,
        smalllabel_printers: [],
        printer_tag: null,
        template: 'adresslapp_med_frankering',
        smalllabel_allow_franking: false,
        address: {
            name: '',
            address_lines: [
                '',
                '',
            ],
            city: '',
            postal_code: '',
            country: 'SE',
        },
        label: {
            lines: [],
            footer: '',
            set_order_status: true,
            print_product: true,
            prod_order_id: null,
            return_order_id: null,
            card_order_id: null,
            delivery_address_id: null,
        },
    }),
    async mounted() {
        this.getPrinters();
        const printerTag = Cookies.get('small_label_printer');
        if (printerTag) {
            this.printer_tag = printerTag;
        }
        await this.fillShipment();
    },
    watch: {
        printer_tag: function smallLabelPrinterTag() {
            this.updateSmallLabelPrinter();
        },
    },
    methods: {
        hasRole,
        getPrinters() {
            const client = new PrinterRepository();
            client.whereIn('media', ['adr_101x38', 'adr_99x49'])
                .where('language', 'zpl')
                .orderBy('name')
                .orderDirection('ASC')
                .setPerPage(999999);

            if (!this.hasRole('super-admin')) {
                client.where('is_dev', 0);
            }

            client.run().then((response) => {
                this.smalllabel_printers = response.data;
                this.updateSmallLabelPrinter();
            });
        },
        updateSmallLabelPrinter() {
            const printer = this.smalllabel_printers.find((p) => p.tag === this.printer_tag);
            if (printer && printer.media === 'adr_99x49') {
                this.smalllabel_allow_franking = true;
                this.template = 'adresslapp_med_frankering';
            } else {
                this.smalllabel_allow_franking = false;
                this.template = 'adresslapp_utan_frankering';
            }
        },
        async printLabel() {
            const isValid = await this.$refs.printlabelform.validate();
            if (isValid) {
                if (this.set_as_defualt_printer) {
                    Cookies.set('small_label_printer', this.printer_tag, { expires: 365 });
                    this.set_as_defualt_printer = false;
                }
                this.busy_printing = true;
                this.label.lines = [];
                this.label.lines.push(this.address.name);
                this.address.address_lines.forEach((line) => {
                    if (line !== '') {
                        this.label.lines.push(line);
                    }
                });
                this.label.lines.push(this.address.city + ' ' + this.address.postal_code);
                if (this.address.country !== 'SE') {
                    this.label.lines.push(this.address.country);
                }
                await apiClient.post('/api/printer/print/address/' + this.printer_tag + '/' + this.template, { labels: [this.label] })
                    .then(() => {
                        this.$refs.btnprintlabel.triggerSaved();
                    })
                    .catch((error) => {
                        const parsederror = getError(error);
                        if (typeof parsederror === 'object') {
                            this.$refs.printlabelform.setErrors(parsederror);
                        }
                        this.$refs.btnprintlabel.triggerFailed();
                    })
                    .finally(() => {
                        this.busy_printing = false;
                    });
            } else {
                this.$refs.btnprintlabel.triggerFailed();
            }
        },
        async fillShipment() {
            const urlParams = new URLSearchParams(window.location.search);
            if (urlParams.has('prod_order_id')) {
                this.label.prod_order_id = urlParams.get('prod_order_id');
            }
            if (urlParams.has('return_order_id')) {
                this.label.return_order_id = urlParams.get('return_order_id');
            }
            if (urlParams.has('card_order_id')) {
                this.label.card_order_id = urlParams.get('card_order_id');
            }
            if (urlParams.has('delivery_address_id')) {
                this.label.delivery_address_id = urlParams.get('delivery_address_id');
            }

            await apiClient.post('/vue/shipping/ntaps/shipment', {
                prod_order_id: this.label.prod_order_id,
                return_order_id: this.label.return_order_id,
                card_order_id: this.label.card_order_id,
                delivery_address_id: this.label.delivery_address_id,
            }).then((res) => {
                if (res.data.shipment && res.data.shipment.receiver && res.data.shipment.receiver.address) {
                    this.address.name = res.data.shipment.receiver.address.name;
                    this.address.city = res.data.shipment.receiver.address.city;
                    this.address.postal_code = res.data.shipment.receiver.address.postal_code;
                    this.address.country = res.data.shipment.receiver.address.country;
                    this.address.address_lines = res.data.shipment.receiver.address.address_lines;
                    this.address.address_lines = [];
                    if (Array.isArray(res.data.shipment.receiver.address.address_lines)) {
                        res.data.shipment.receiver.address.address_lines.forEach((line) => {
                            this.address.address_lines.push(line);
                        });
                    }
                    const footer = [];
                    const ref = res.data.shipment.internal_data?.internal_reference3 ?? res.data.shipment.reference ?? '';
                    if (ref) {
                        footer.push(ref);
                    }
                    const skus = [];
                    const goods = res.data.shipment.contents?.goods ?? [];
                    goods.forEach((g) => {
                        skus.push(g.sku);
                    });
                    if (skus.length > 0) {
                        footer.push('SKU: ' + skus.join(';'));
                    }
                    this.label.footer = footer.join(' | ');

                    // eslint-disable-next-line no-plusplus
                    for (let i = 0; i < 2 - this.address.address_lines.length; i++) {
                        this.address.address_lines.push('');
                    }
                }
            });
        },
    },
    computed: {
        order_route() {
            if (this.label.prod_order_id) {
                return { name: 'prodorders.edit', params: { id: this.label.prod_order_id } };
            }
            if (this.label.return_order_id) {
                return { name: 'returnorder.edit', params: { id: this.label.return_order_id } };
            }
            if (this.label.card_order_id) {
                return { name: 'cardorders.edit', params: { id: this.label.card_order_id } };
            }

            return null;
        },
    },
};
</script>
